//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  input
} from '@angular/core';

import {
  FormGroup
} from '@angular/forms';

@Component({
    selector: 'checkbox',
    templateUrl: './checkbox.component.html',
    styleUrl: './checkbox.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckboxComponent {

  public id = input.required<string>();
  public formGroup = input<FormGroup>();
  public checked = input<boolean>(false);
  public innerClass = input<string>('');
  public disabled = input<boolean>(false);
  public indeterminate = input<boolean>(false);

  @Output()
  public change = new EventEmitter();

  constructor() { }


}
